/* eslint-disable camelcase */
import { trackEvent } from '@fs/zion-analytics'
import type { analytics } from '../types/data-types'

export default function sendAnalytics(values: analytics): void {
  const data: Record<string, string> = {
    link_app: 'tree-ancestors-r9',
  }
  if (values.link_page) {
    data.link_page = values.link_page
  }
  if (values.link_name) {
    data.link_name = values.link_name
  }
  trackEvent(data)
}
